import { useAtom } from 'jotai';
import { filterListBottomSheetAtom } from './filterListBottomSheet.atom';
import { filterListBottomSheetStore } from './FilterListBottomSheetAtomProvider';
import { useEffect } from 'react';
import { useFilterListAtom } from '../filterList/useFilterListAtom';

export const useFilterListBottomSheetAtom = () => {
  const [filterListBottomSheetAtomValue, setFilterListBottomSheetAtomValue] =
    useAtom(filterListBottomSheetAtom, { store: filterListBottomSheetStore });
  const { filterListAtomValue, setFilterListAtom, replaceFilterListAtom } = useFilterListAtom();

  useEffect(() => {
    setFilterListBottomSheetAtomValue(filterListAtomValue);
  }, [filterListAtomValue, setFilterListBottomSheetAtomValue]);

  /**
   * - queryName에 해당하는 key를 queryValue로 설정하는 경우 사용
   * - 바텀시트와 실제 필터를 동시에 업데이트하여 즉시 반영
   */
  const setFilterListBottomSheetViaQueryValue: SetFilterListBottomSheetViaQueryValue =
    ({ queryName, queryValue }) => {
      const nextValue = { [queryName]: queryValue };

      // 1. 바텀시트 상태 업데이트 (UI용)
      setFilterListBottomSheetAtomValue(prev => ({
        ...prev,
        ...nextValue,
      }));

      // 2. 실제 필터 상태 업데이트 (API 요청용) - 즉시 반영!
      setFilterListAtom(prev => ({
        ...prev,
        ...nextValue,
      }));
    };

  const clearFilterListBottomSheet = () => {
    setFilterListBottomSheetAtomValue({});
    replaceFilterListAtom({}); // merge가 아닌 전체 교체로 검색 atom 초기화
  };
  return {
    filterListBottomSheetAtomValue,
    setFilterListBottomSheetViaQueryValue,
    clearFilterListBottomSheet,
  };
};

export type SetFilterListBottomSheetViaQueryValueProps = {
  queryName: string;
  queryValue: string | string[];
};

export type SetFilterListBottomSheetViaQueryValue = (
  props: SetFilterListBottomSheetViaQueryValueProps,
) => void;
